import { httpClient } from '../lib/http-client';
import { Usuario, Departamento, Unidade } from '../types';
import { TIMEOUTS } from '../config/constants';

/**
 * Service para gerenciamento de usuários
 */
export class UsuariosService {
  static async getUsuarios(): Promise<Usuario[]> {
    return httpClient.get<Usuario[]>('/api/usuarios');
  }

  static async getUsuario(id: number): Promise<Usuario> {
    return httpClient.get<Usuario>(`/api/usuarios/${id}`);
  }

  static async getUsuarioRelacionamentos(
    id: number
  ): Promise<{ departamentos: Departamento[]; unidades: Unidade[] }> {
    return httpClient.get<{ departamentos: Departamento[]; unidades: Unidade[] }>(
      `/api/usuarios/${id}/relacionamentos`
    );
  }

  static async atualizarUsuarioRelacionamentos(
    id: number,
    data: { nivel: string; departamentos?: number[]; unidades?: number[] }
  ): Promise<{ success: boolean }> {
    return httpClient.put<{ success: boolean }>(
      `/api/usuarios/${id}/relacionamentos`,
      data
    );
  }

  static async createUsuario(data: Partial<Usuario>): Promise<Usuario> {
    return httpClient.post<Usuario>('/api/usuarios', data);
  }

  static async updateUsuario(id: number, data: Partial<Usuario>): Promise<Usuario> {
    return httpClient.put<Usuario>(`/api/usuarios/${id}`, data);
  }

  static async deleteUsuario(id: number): Promise<{ success: boolean }> {
    return httpClient.delete<{ success: boolean }>(`/api/usuarios/${id}`);
  }

  static async toggleUsuarioStatus(id: number): Promise<{ status: number }> {
    return httpClient.patch<{ status: number }>(`/api/usuarios/${id}/toggle-status`);
  }

  static async getPerfil(): Promise<Usuario> {
    return httpClient.get<Usuario>('/api/perfil');
  }

  static async updatePerfil(data: Partial<Usuario>): Promise<Usuario> {
    return httpClient.post<Usuario>('/api/perfil', data);
  }

  static async getPerfilPublico(id: number): Promise<Partial<Usuario>> {
    return httpClient.get<Partial<Usuario>>(`/api/usuarios/${id}/perfil-publico`);
  }

  static async uploadAvatar(
    formData: FormData
  ): Promise<{ success: boolean; avatar: string | null }> {
    return httpClient.upload<{ success: boolean; avatar: string | null }>(
      '/api/usuarios/avatar',
      formData,
      TIMEOUTS.AVATAR
    );
  }
}

